import { Box } from "@mui/material";
import React from "react";
import { IndicadorEstado } from "../../ContratosCreation/components/IndicadorEstado/IndicadorEstado";

export const TagWarningInfo = ({ text }) => {
    return (
        <Box sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            borderRadius: "5px",
            border: "1px solid #E0E1E3",
            padding: "3px 6px",
            backgroundColor: "#F5F5F5"
        }}>
            <div>
                <IndicadorEstado type={'warning'} />
            </div>
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box>{text}</Box>
            </Box>
        </Box>
    )
}
